module.exports = __webpack_public_path__ + "static/sinead-slideshow-02-73ea009addefff275d0af6c4b62ec396.jpg";